module.exports = __webpack_public_path__ + "static/media/bee-logo-2021.7414e6db.svg";